<template>
  <div class="ui-item">
    <img :src="$props.image" alt="">
    <span class="ui-item-title">{{ $props.title }}</span>
    <base-button @click="updateComponent">{{ $props.buttonText }}</base-button>
  </div>
</template>

<script>
import BaseButton from '@/components/base/base-button'

export default {
  name: 'user-identification-item',
  components: { BaseButton },
  props: {
    image: String,
    title: String,
    buttonText: String,
    contractType: String
  },

  methods: {
    updateComponent () {
      this.$emit('update-component', this.$props.contractType)
    }
  }
}
</script>

<style lang="scss" scoped>
.ui-item {
  background: $white;
  text-align: center;

  @media (map_get($breakpoints, sm)) {
    flex: 0 0 22rem;
    margin: 0 auto;
  }

  @media (map_get($breakpoints, md)) {
    flex: 0 0 auto;
  }
}

.ui-item-title {
  display: block;
  margin: 2.4rem 0;
  font-size: 2rem;

  @media (map_get($breakpoints, sm)) {
    font-size: 2.4rem;
    line-height: 1.25;
  }
}
</style>
